export const EMPTY_SELECT_REQUIRED = 0;
export const EMPTY_SELECT_NONE = 2;

/**
 * Legacy reservations can retain deleted state2 IDs starting at 0. When the
 * entire state2 setting is already missing, reserve 0-9 to avoid binding
 * those reservations to newly created states.
 */
export const STATE2_RECREATE_INITIAL_ID = 10;

/**
 * Resolve the initial value for a reservation state on a new reservation.
 * When blank values are disabled, an absent or disabled configured default
 * falls back to the first enabled state, matching reservation extension items.
 */
export const getInitialResvStateValue = (resvStates, idx, configuredDefault) => {
  const resvState = resvStates?.find(state => Number(state.idx) === Number(idx));
  if (Number(resvState?.emptySelect) !== EMPTY_SELECT_NONE) {
    return configuredDefault;
  }

  const enabledStates = resvState.datas?.filter(data => data.isUsing ?? true) ?? [];
  const configuredState = enabledStates.find(data => String(data.id) === String(configuredDefault));
  return configuredState?.id ?? enabledStates[0]?.id ?? configuredDefault;
};

export const isResvStateRequired = resvState =>
  Number(resvState?.emptySelect) === EMPTY_SELECT_REQUIRED;

/**
 * Keep issuing state IDs from the persisted high-water mark even when the
 * state setting itself was deleted and later recreated.
 */
export const getResvStateNextId = (resvState, persistedNextId, initialNextId = 1) =>
  resvState?.nextId ?? persistedNextId ?? initialNextId;

export const getResvStateSettingNextId = (idx, resvState, persistedNextId) =>
  getResvStateNextId(
    resvState,
    persistedNextId,
    Number(idx) === 2 ? STATE2_RECREATE_INITIAL_ID : 1,
  );

export const getResvItemWidthClass = item =>
  Number(item?.viewWidth) === 2 ? 'resv-col-full' : 'resv-col';
